import PublicHttpClient from '../../services/public-http-client';
import { IAttachmentResponse } from '../../../model/sge/attachment/response/attachment-response';

const basePath = (clientId: number) => `Public/Client/${clientId}/Attachment`;

const list = async (clientId: number, entityType: string, entityId: number): Promise<IAttachmentResponse[]> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId)}/${entityType}/${entityId}`
    }).then((response) => response.data);
};

const download = async (clientId: number, id: number): Promise<Blob> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId)}/${id}/Download`,
        responseType: 'blob'
    }).then((response) => response.data);
};

const PublicAttachmentAppService = { list, download };
export default PublicAttachmentAppService;
